import React from 'react'
import Cookies from 'js-cookie';


class CacheTester extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      cookieValue: null
    }
  }

  componentDidMount() {
    Cookies.set('snappycookie', 'MAH COOKEH!');
  }

  render() {

    const { cookieValue } = this.state;

    return (
      <div className="CacheTester">
        <h1>Cache Test:</h1>
        <div>
          <h4>Cookie Cache:</h4>
          <p>
            <button onClick={()=> this.onCheckCookie()}>Check cookie value</button>
          </p>
          <p>
            Cookie value: <span className="the-cookie">{cookieValue ? cookieValue : "Null"}</span>
          </p>
        </div>
      </div>
    )
  }

  onCheckCookie() {
    var mahCookies = Cookies.get();
    this.setState({
      cookieValue: mahCookies.snappycookie
    })
  }

}

export default CacheTester;



// WEBPACK FOOTER //
// ./src/components/testplayground/CacheTester.js